import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { companyList } from "../../apis/api/DataApi";
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { insertTransaction, insertRequest } from "../../apis/api/NMMBusinessApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import PaymentAnimation from "./PaymentAnimation";
import "./BusinessImpact.css";

const MODES    = ["Bank Transfer","UPI","Cheque","Cash","Online Gateway"];
const STATUSES = ["Advance","Partial","Full","Final Settlement"];

export default function AddBuisness() {
  const { register, handleSubmit, control, reset, watch,
    formState:{ errors } } = useForm({ defaultValues:{ date: new Date() } });

  const [mode,    setMode]    = useState("pay");       // pay | request
  const [payStep, setPayStep] = useState("idle");      // idle | processing | success

  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const { CompanyList } = useSelector((s) => s.DataSlice);
  const { loading }     = useSelector((s) => s.NmmBuisness);
  const company_id      = Cookies.get("company_id");

  const options = CompanyList.filter(v => v?.value?.split(":")[0] !== company_id);

  useEffect(() => { dispatch(companyList()); }, []);

  const onSubmit = async (data) => {
    setPayStep("processing");
    const fd = new FormData();
    fd.append("Recever_company", data.company?.value);
    fd.append("Sender_company",  company_id);
    fd.append("Transaction_Date", new Date(data.date).getTime());
    fd.append("amount",   data.amount);
    fd.append("mode",     data.mode);
    fd.append("Payment_status", data.status);
    fd.append("comment",  data.comment);

    try {
      let res;
      if (mode === "pay") { fd.append("payPass", data.payPass); res = await dispatch(insertTransaction(fd)); }
      else                { res = await dispatch(insertRequest(fd)); }

      if (res.payload.status === "success") {
        setPayStep("success");
        toast.success(res.payload.message);
        reset();
        setTimeout(() => { setPayStep("idle"); navigate("/Businessimpact"); }, 2200);
      } else {
        setPayStep("idle");
        toast.error(res.payload.message);
      }
    } catch { setPayStep("idle"); toast.error("Something went wrong."); }
  };

  const selMode   = watch("mode");
  const selStatus = watch("status");

  return (
    <motion.div className="bi-page"
      initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }}
      transition={{ duration:.4, ease:[.22,.68,0,1.2] }}>

      {/* ── TOP HEADER ── */}
      <div className="bi-page-header">
        <div>
          <h1 className="bi-page-title">
            {mode === "pay" ? "Send Payment" : "Request Payment"}
          </h1>
          <p className="bi-page-sub">
            {mode === "pay"
              ? "Transfer funds securely to another member."
              : "Request a payment from another member."}
          </p>
        </div>
        {/* mode toggle */}
        <div className="bi-toggle">
          <button type="button"
            className={`bi-toggle-btn ${mode==="pay"?"active":""}`}
            onClick={() => { setMode("pay"); setPayStep("idle"); }}>
            <i className="bx bx-send"></i> Pay
          </button>
          <button type="button"
            className={`bi-toggle-btn ${mode==="request"?"active":""}`}
            onClick={() => { setMode("request"); setPayStep("idle"); }}>
            <i className="bx bx-receipt"></i> Request
          </button>
        </div>
      </div>

      {/* ── MAIN LAYOUT ── */}
      <div className="bi-layout">

        {/* LEFT — form */}
        <motion.div className="bi-form-card" key={mode}
          initial={{ opacity:0, x:-14 }} animate={{ opacity:1, x:0 }}
          transition={{ duration:.35 }}>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>

            {/* Company */}
            <div className="bi-field">
              <label className="bi-label">Company <span>*</span></label>
              <Controller name="company" control={control}
                rules={{ required:"Company is required" }}
                render={({ field }) => (
                  <Select {...field} options={options} placeholder="Select company…"
                    styles={{
                      control:(b,s)=>({ ...b, borderRadius:"10px", minHeight:"42px",
                        borderColor: errors.company?"#ef4444": s.isFocused?"#586AD9":"#e5e7eb",
                        boxShadow: s.isFocused?"0 0 0 3px rgba(88,106,217,.10)":"none",
                        fontSize:".875rem", background:"#fafafa" }),
                      option:(b,s)=>({ ...b, fontSize:".875rem",
                        background: s.isSelected?"#586AD9": s.isFocused?"#eef0fb":"#fff",
                        color: s.isSelected?"#fff":"#0f172a" }),
                    }} />
                )} />
              {errors.company && <span className="bi-error">{errors.company.message}</span>}
            </div>

            {/* Amount */}
            <div className="bi-field">
              <label className="bi-label">Amount <span>*</span></label>
              <div className="bi-input-prefix">
                <span className="bi-prefix">$</span>
                <input className={`bi-input bi-input-with-prefix ${errors.amount?"error":""}`}
                  type="number" placeholder="0.00"
                  {...register("amount",{ required:"Amount is required", min:{ value:1, message:"Min $1" } })} />
              </div>
              {errors.amount && <span className="bi-error">{errors.amount.message}</span>}
            </div>

            {/* PayPass — only for pay */}
            <AnimatePresence>
              {mode === "pay" && (
                <motion.div className="bi-field" key="pp"
                  initial={{ opacity:0, height:0, marginBottom:0 }}
                  animate={{ opacity:1, height:"auto", marginBottom:"1.1rem" }}
                  exit={{ opacity:0, height:0, marginBottom:0 }}
                  transition={{ duration:.25 }} style={{ overflow:"hidden" }}>
                  <label className="bi-label">Pay Password <span>*</span></label>
                  <input className={`bi-input ${errors.payPass?"error":""}`}
                    type="password" placeholder="Enter your PayPass"
                    {...register("payPass",{ required:"PayPass is required", minLength:{ value:4, message:"Min 4 chars" } })} />
                  {errors.payPass && <span className="bi-error">{errors.payPass.message}</span>}
                </motion.div>
              )}
            </AnimatePresence>

            {/* Mode chips */}
            <div className="bi-field">
              <label className="bi-label">Transaction Mode <span>*</span></label>
              <div className="bi-chips">
                {MODES.map(m => (
                  <label key={m} className={`bi-chip ${selMode===m?"selected":""}`}>
                    <input type="radio" value={m} {...register("mode",{ required:"Select a mode" })} />
                    {m}
                  </label>
                ))}
              </div>
              {errors.mode && <span className="bi-error">{errors.mode.message}</span>}
            </div>

            {/* Status chips */}
            <div className="bi-field">
              <label className="bi-label">Payment Status <span>*</span></label>
              <div className="bi-chips">
                {STATUSES.map(s => (
                  <label key={s} className={`bi-chip ${selStatus===s?"selected":""}`}>
                    <input type="radio" value={s} {...register("status",{ required:"Select a status" })} />
                    {s}
                  </label>
                ))}
              </div>
              {errors.status && <span className="bi-error">{errors.status.message}</span>}
            </div>

            {/* Date */}
            <div className="bi-field">
              <label className="bi-label">Transaction Date <span>*</span></label>
              <Controller name="date" control={control}
                rules={{ required:"Date is required" }}
                render={({ field }) => (
                  <DatePicker {...field} selected={field.value}
                    className={`bi-input ${errors.date?"error":""}`}
                    dateFormat="dd/MM/yyyy" wrapperClassName="bi-date-wrap" />
                )} />
              {errors.date && <span className="bi-error">{errors.date.message}</span>}
            </div>

            {/* Comment */}
            <div className="bi-field">
              <label className="bi-label">Comment <span>*</span></label>
              <textarea className={`bi-input ${errors.comment?"error":""}`} rows={3}
                placeholder="Add a note about this transaction…"
                {...register("comment",{ required:"Comment is required", minLength:{ value:3, message:"Min 3 chars" } })} />
              {errors.comment && <span className="bi-error">{errors.comment.message}</span>}
            </div>

            <button type="submit" className="bi-submit" disabled={loading || payStep==="processing"}>
              {payStep === "processing"
                ? <><motion.i className="bx bx-loader-circle"
                    animate={{ rotate:360 }} transition={{ duration:1, repeat:Infinity, ease:"linear" }} /> Processing…</>
                : <><i className={mode==="pay"?"bx bx-send":"bx bx-receipt"}></i>
                    {mode==="pay" ? "Send Payment" : "Send Request"}</>}
            </button>
          </form>
        </motion.div>

        {/* RIGHT — payment animation */}
        <div className="bi-anim-panel">
          <PaymentAnimation mode={mode} />
        </div>

      </div>
    </motion.div>
  );
}
